import React from 'react';
import BlogfaqFile from '../../JsonData/blogfaq.json';


const BlogFaqs = ({ blogId }) => {
  // Safely extract the array
  const BlogfaqData = BlogfaqFile?.BlogfaqData || [];

  // Find the FAQ section matching the blogId
  const matchedFaqSection = BlogfaqData.find(section => section.id === blogId);

  if (!matchedFaqSection) {
    return (
      <div className="faq-area pd-top-70 pd-bottom-50">
        <div className="container">
          <h2 className="title mb-4">Frequently Asked Questions</h2>
          <p>No FAQs found for this blog.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="faq-area pd-top-70 pd-bottom-100">
      <div className="container">
        <h2 className="title mb-4">Frequently Asked Questions</h2>

        <div className="accordion mb-5" id={`accordion-${matchedFaqSection.id}`}>
          <h4 className="mb-3">{matchedFaqSection.section}</h4>

          {matchedFaqSection.faqs.map((faq, i) => (
            <div key={i} className="single-accordion card">
              <div className="card-header" id={`heading-${matchedFaqSection.id}-${i}`}>
                <h2 className="lb-0">
                  <button
                    style={{fontSize :"15px" ,}}                  
                    className="btn-link"
                    type="button"
                    data-toggle="collapse"
                    data-target={`#collapse-${matchedFaqSection.id}-${i}`}
                    aria-expanded={i === 0 ? 'true' : 'false'}
                    aria-controls={`collapse-${matchedFaqSection.id}-${i}`}
                  >
                    {faq.question}
                  </button>
                </h2>
              </div>
              <div
                id={`collapse-${matchedFaqSection.id}-${i}`}
                className={`collapse ${i === 0 ? 'show' : ''}`}
                aria-labelledby={`heading-${matchedFaqSection.id}-${i}`}
                data-parent={`#accordion-${matchedFaqSection.id}`}
              >
                <div className="card-body" style={{fontSize :"15px"}}>{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Share Section */}
        <div className="mt-4">
          <p className="fw-semibold"><strong>Share:</strong></p>
          <ul className="social-icon">
            <li>
                <a href="https://www.facebook.com/profile.php?id=61574452610932 " target="_blank"><i className="fa fa-facebook" /></a>
                    <a href="https://x.com/TrinestSky?t=0nIVrZfREEaavLFy1dJrQQ&s=09" target="_blank"><img src='/icons8-x-50.png' style={{ width: "15px", marginTop: "-5px" }} /></a>
                    <a href="https://www.linkedin.com/company/trinest-sky-real-estate/" target="_blank"><i className="fa fa-linkedin" /></a>
                    <a href="https://www.instagram.com/trinestsky/" target="_blank"><i className="fa fa-instagram" /></a>
                     <a href="https://www.youtube.com/channel/UCKrImHaqk4uHfAsHt9Ak4kg" target="_blank"><i class="fa-brands fa-youtube"></i></a>
                        <a href="https://www.tiktok.com/@trinestskyrealestate?lang=en" target="_blank"><i class="fa-brands fa-tiktok"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BlogFaqs;
